import React from 'react'
import { SectionPaper, SectionTitle } from 'components/startup/startup-styles'
import { Column } from 'components/common/layout'
import { checkEditorDefaultValue } from 'utils/validations'
import { TextViewer } from 'components/common/text-editor'

export const EffortForDev: React.FC<{ effortForDev: string }> = ({
  effortForDev,
}) => {
  if (!effortForDev || checkEditorDefaultValue(effortForDev)) return null
  return (
    <Column id='effortForDev'>
      <SectionTitle>팀원을 위한 노력</SectionTitle>
      <SectionPaper>
        <TextViewer value={effortForDev} />
      </SectionPaper>
    </Column>
  )
}
